Object.defineProperty(exports, "__esModule", {
  value: true
});

var _airbnbPropTypes = require('airbnb-prop-types');

var _headingLevels = require('../headingLevels');

// `range(x, y)` is `[x, y)` by convention, hence the +1
exports['default'] = (0, _airbnbPropTypes.range)(_headingLevels.MIN_HEADING_LEVEL, _headingLevels.MAX_HEADING_LEVEL + 1);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/headingLevelRange.js
// module id = 158
// module chunks = 168707334958949